var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStationLocator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2.75C14.4186 2.75 8.25 8.64961 8.25 15.8984C8.25 19.3505 9.82352 23.9413 12.9267 29.5436C15.4189 34.0416 18.3021 38.109 19.8017 40.1328C20.0551 40.4786 20.3864 40.7598 20.7688 40.9537C21.1512 41.1475 21.5739 41.2486 22.0026 41.2486C22.4313 41.2486 22.854 41.1475 23.2363 40.9537C23.6187 40.7598 23.95 40.4786 24.2034 40.1328C25.7005 38.109 28.5863 34.0416 31.0784 29.5436C34.1765 23.943 35.75 19.3523 35.75 15.8984C35.75 8.64961 29.5814 2.75 22 2.75Z",
    fill: "#39B6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2531 19.0294H28.9424C29.3202 19.0284 29.6649 19.2199 29.8257 19.5223C29.9865 19.8247 29.9347 20.1815 29.6924 20.4381L19.3259 31.488C19.1321 31.6786 18.8193 31.734 18.5583 31.6232C18.2973 31.5123 18.1497 31.2625 18.1982 31.0097L20.3039 21.5649H15.0485C14.7533 21.5629 14.4747 21.4433 14.2908 21.2392C14.1069 21.036 14.0375 20.7696 14.1014 20.5149L16.9206 9.47168C17.0164 9.08086 17.4063 8.80183 17.8589 8.79989H25.2178C25.5239 8.796 25.8125 8.92336 25.9931 9.14114C26.1803 9.3521 26.2409 9.63014 26.1572 9.88778L23.2531 19.0294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationLocator);
export default __webpack_public_path__ + "static/media/station-locator.030ba3dd5d78eaf43ad3cc133b5e5340.svg";
export { ForwardRef as ReactComponent };